<template>
  <div>checkMeeting</div>
</template>

<script>
export default {
  name: 'CheckMeeting',
}
</script>

<style lang="less" scoped></style>
